import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NondigitalService {
  constructor(private readonly http: HttpClient) {}
  getNonDigitalData(): Observable<any> {
    return this.http.get('assets/data/uim-ui/non-digital.json');
  }
}
